import axios from "axios";

const apiURL = process.env.REACT_APP_API_URL + "api";

export const fetchProducts = (page) => {
  return axios.get(`${apiURL}/product/all/${page}`);
};

export const fetchProduct = (id) => {
  return axios.get(`${apiURL}/product/${id}`);
};

export const fetchProductsByBestSeller = (page) => {
  return axios.get(`${apiURL}/product/best-sellers/${page}`);
};

export const fetchProductsByWholeSale = (page) => {
  return axios.get(`${apiURL}/product/whole-sale/${page}`);
};

export const fetchProductsBySearch = (query, page) => {
  return axios.get(`${apiURL}/product/search/${query}/${page}`);
};

export const fetchProductsBycategory = (page, cat) => {
  return axios.get(`${apiURL}/product/category/${cat}/${page}`);
};

export const sendMessage = (data) => {
  return axios.post(`${apiURL}/message/sendMail`, data);
};

export const login = (data) => {
  return axios.post(`${apiURL}/auth/signin`, data);
};

export const signup = (data) => {
  return axios.post(`${apiURL}/auth/signup`, data);
};

export const verifyEmail = (token) => {
  return axios.put(`${apiURL}/auth/email-verify/${token}`);
};

export const forgetPassword = (data) => {
  return axios.post(`${apiURL}/auth/forget-password`, data);
};

export const resetPasswordFp = (data) => {
  return axios.put(`${apiURL}/auth/reset-password-fp`, data);
};

export const initPayment = (data) => {
  return axios.post(`${apiURL}/order/add`, data);
};

export const initEnrollment = (data) => {
  return axios.post(`${apiURL}/enroll/add`, data);
};

export const paymentApproved = (reference, data) => {
  return axios.put(`${apiURL}/order/success/${reference}`, data);
};

export const enrollmentApproved = (reference, data) => {
  return axios.put(`${apiURL}/enroll/success/${reference}`, data);
};

export const fetchUserOrder = (userId, token) => {
  return axios.get(`${apiURL}/order/user/${userId}`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const fetchUserEnrollments = (userId, token) => {
  return axios.get(`${apiURL}/enroll/user/${userId}`, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const updateProfile = (data, userId, token) => {
  return axios.put(`${apiURL}/auth/update-profile/${userId}`, data, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const changePassword = (data, userId, token) => {
  return axios.put(`${apiURL}/auth/change-password/${userId}`, data, {
    headers: { Authorization: "Bearer " + token },
  });
};
